import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

function ErrorCard() {
  return (
    <div class="bg-orange-200 px-6 py-4 my-4 rounded-md text-lg flex gap-2  items-center mx-auto max-w-lg">
      <FontAwesomeIcon
        icon={faTriangleExclamation}
        className="text-yellow-600"
      />
      <span class="text-yellow-800">Something went wrong...</span>
    </div>
  )
}
export default ErrorCard